/**
 * Entry point for the blood-test page template (layout/blood-test.liquid).
 * One file per template — every section on this template shares this bundle.
 */
import initBloodTestHeaderScroll from 'JsComponents/blood-test-header-scroll.js';
import initBloodTestComparisonTabs from 'JsComponents/blood-test-comparison-tabs.js';
import initBloodTestOfferTabs from 'JsComponents/blood-test-offer-tabs.js';
import initBloodTestPanelModal from 'JsComponents/blood-test-panel-modal.js';
import initBloodTestModalScrollbar from 'JsComponents/blood-test-modal-scrollbar.js';
// Reused as-is from the homepage — the signals rail implements the same
// [data-homepage-rail] / [data-rail-track] contract. The component is not modified.
import initHomepageRail from 'JsComponents/homepage-rail';
// §10 reuses sections/homepage-faq.liquid verbatim, so its accordion comes along too.
import initFaqAccordion from 'JsComponents/faq-accordion';
import initMeetingFormLinks from 'JsComponents/meeting-form-links.js';
import initBloodTestGa4 from 'JsComponents/blood-test-ga4.js';

let headerScroll = null;
let comparisonTabs = null;
let offerTabs = null;
let panelModal = null;
let modalScrollbar = null;
let meetingLinks = null;
let ga4 = null;

function init() {
  if (headerScroll) headerScroll.destroy();
  if (comparisonTabs) comparisonTabs.destroy();
  if (offerTabs) offerTabs.destroy();
  if (panelModal) panelModal.destroy();
  if (modalScrollbar) modalScrollbar.destroy();
  if (meetingLinks) meetingLinks.destroy();
  if (ga4) ga4.destroy();

  headerScroll = initBloodTestHeaderScroll();
  comparisonTabs = initBloodTestComparisonTabs();
  offerTabs = initBloodTestOfferTabs();
  panelModal = initBloodTestPanelModal();
  modalScrollbar = initBloodTestModalScrollbar();
  meetingLinks = initMeetingFormLinks();
  ga4 = initBloodTestGa4();
  initHomepageRail();
  initFaqAccordion();
}

// Guard for already-parsed DOM (the bundle can execute after DOMContentLoaded fires).
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Re-init when a blood-test section reloads in the theme editor.
document.addEventListener('shopify:section:load', (e) => {
  if (
    e.target.querySelector(
      '[data-blood-test-header], [data-blood-test-comparison], [data-blood-test-offer-tabs], [data-homepage-rail], .homepage-faq, [data-bt-modal]'
    )
  ) {
    init();
  }
});
